import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api/axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { toast } from 'sonner';
import { Lock, ShieldCheck, Loader2, ArrowLeft } from 'lucide-react';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const tokenFromUrl = searchParams.get('token') || '';
  
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast.error('As senhas nao coincidem!');
      return;
    }
    if (newPassword.length < 6) {
      toast.error('A senha deve ter no minimo 6 caracteres');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token: tokenFromUrl, new_password: newPassword });
      toast.success('Senha alterada com sucesso!');
      setSuccess(true);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Token invalido ou expirado. Solicite um novo link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#003366] to-[#001a33] p-4">
      <Card className="w-full max-w-md" data-testid="reset-password-card">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-16 h-16 bg-[#003366] rounded-full flex items-center justify-center">
            <Lock className="text-white" size={32} />
          </div>
          <CardTitle className="text-2xl text-[#003366]">Redefinir Senha</CardTitle>
          <CardDescription>
            {success ? 'Senha alterada com sucesso!' : 'Crie uma nova senha para sua conta'}
          </CardDescription>
        </CardHeader>

        <CardContent>
          {!success ? (
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="reset-form">
              {!tokenFromUrl && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                  <p className="text-sm text-red-700">Link invalido. Solicite um novo link de recuperacao.</p>
                </div>
              )}

              <div className="space-y-2">
                <Label htmlFor="newPassword">Nova Senha</Label>
                <Input
                  id="newPassword"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Minimo 6 caracteres"
                  required
                  data-testid="reset-new-password"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="confirmPassword">Confirmar Senha</Label>
                <Input
                  id="confirmPassword"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Repita a senha"
                  required
                  data-testid="reset-confirm-password"
                />
              </div>
              
              <Button type="submit" className="w-full bg-[#003366] hover:bg-[#002244]" disabled={loading || !tokenFromUrl} data-testid="reset-submit-btn">
                {loading ? <><Loader2 className="animate-spin mr-2" size={16} /> Redefinindo...</> : 'Redefinir Senha'}
              </Button>

              <Link to="/login" className="text-sm text-[#0066CC] hover:underline flex items-center justify-center gap-1">
                <ArrowLeft size={16} /> Voltar ao Login
              </Link>
            </form>
          ) : (
            <div className="text-center space-y-4">
              <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                <ShieldCheck className="text-green-600" size={32} />
              </div>
              <p className="text-gray-600">Sua senha foi alterada com sucesso!<br />Voce ja pode fazer login.</p>
              <Link to="/login">
                <Button className="w-full bg-[#003366] hover:bg-[#002244]">Ir para o Login</Button>
              </Link>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
